import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Loader } from "semantic-ui-react";
import _ from "lodash";

import "../PartyLayout/Votify.css";
import TracksWithVotesList from "./TracksWithVotesList";
import { sendVote } from "../VotifyParticipant/participantActionCreators";

class TrackQueue extends Component {
  constructor(props) {
    super(props);

    this.queueCompare = this.queueCompare.bind(this);
  }

  queueCompare(a) {
    return -this.props.votes[a.uri];
  }

  shouldComponentUpdate(nextProps) {
    const shouldUpdate = !(
      _.isEqual(nextProps.votes, this.props.votes) &&
      _.isEqual(nextProps.tracks, this.props.tracks)
    );
    console.log(`TrackQueue.shouldComponentUpdate: ${shouldUpdate}`);
    return shouldUpdate;
  }

  render() {
    if (this.props.tracks && this.props.votes) {
      return (
        <div>
          <TracksWithVotesList
            clickVote={this.props.clickVote}
            participantVotes={this.props.participantVotes}
            tracks={_.sortBy(
              Object.values(this.props.tracks),
              this.queueCompare,
            )}
            votes={this.props.votes}
          />
        </div>
      );
    } else {
      return (
        <Loader
          active
          content={
            <span style={{ color: "ghostwhite" }}>counting votes ...</span>
          }
        />
      );
    }
  }
}

TrackQueue.propTypes = {
  clickVote: PropTypes.func.isRequired,
  tracks: PropTypes.object.isRequired,
  votes: PropTypes.object.isRequired,
  participantVotes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    votes: state.participant.votes,
    participantVotes: state.participant.participantVotes,
    tracks: state.queue.tracks,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clickVote: (trackId, partyId) => dispatch(sendVote(trackId, partyId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TrackQueue);
